import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge.js";
import moment from "moment";
import apiService from "apiService";

HighchartsMore(Highcharts);
solidGauge(Highcharts);

const PelayananHt = ({ dat, loading }) => {
  const [data, setdata] = useState({
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: "pie",
    },
    title: {
      text: "Pelayanan SPM",
    },
    tooltip: {
      pointFormat: "{series.name}: <b> {point.y} %</b>",
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.y} %",
        },
      },
    },
    series: [],
  });
  useEffect(() => {
    if (!loading) {
      getData();
    }
  }, [loading]);

  const getData = async () => {
    setdata({
      ...data,
      series: [
        {
          name: "Pelayanan SPM",
          colorByPoint: true,
          data: [
            {
              name: "Tercapai",
              y: Number((dat.data1 / (dat.data1 + dat.data2) * 100).toFixed(2)),
              sliced: true,
              selected: true,
            },
            {
              name: "Tidak Tercapai",
              y: Number((dat.data2 / (dat.data1 + dat.data2) * 100).toFixed(2)),
            }
          ],
        },
      ],
    });
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={data} />
    </div>
  );
};

export default PelayananHt;
